import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CircleQuestionIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 20, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C4.47301 0 0 4.4725 0 10C0 15.5269 4.4725 20 10 20C15.527 20 20 15.5275 20 10C20 4.47301 15.5275 0 10 0ZM10 18.6046C5.25539 18.6046 1.39535 14.7446 1.39535 10C1.39535 5.25535 5.25539 1.39535 10 1.39535C14.7446 1.39535 18.6046 5.25535 18.6046 10C18.6046 14.7446 14.7446 18.6046 10 18.6046Z"
        fill="currentColor"
      />
      <path
        d="M9.70352 12.6523C9.15066 12.6523 8.70312 13.113 8.70312 13.6659C8.70312 14.2056 9.1375 14.6795 9.70352 14.6795C10.2695 14.6795 10.717 14.2056 10.717 13.6659C10.717 13.113 10.2563 12.6523 9.70352 12.6523Z"
        fill="currentColor"
      />
      <path
        d="M9.87828 4.98047C8.10125 4.98047 7.28516 6.03355 7.28516 6.74434C7.28516 7.25769 7.71953 7.49465 8.07492 7.49465C8.78574 7.49465 8.49617 6.48105 9.83879 6.48105C10.4969 6.48105 11.0235 6.77066 11.0235 7.37617C11.0235 8.08695 10.2863 8.495 9.85195 8.86355C9.47019 9.19258 8.97004 9.73231 8.97004 10.8643C8.97004 11.5488 9.15434 11.7463 9.69398 11.7463C10.3389 11.7463 10.4706 11.4567 10.4706 11.2065C10.4706 10.5221 10.4837 10.1272 11.2077 9.56117C11.5631 9.28477 12.682 8.38965 12.682 7.15234C12.682 5.91504 11.5631 4.98047 9.87828 4.98047Z"
        fill="currentColor"
      />
    </svg>
  )
})

CircleQuestionIcon.displayName = 'CircleQuestionIcon'
